module.exports = "/_next/static/images/AicpaSocBadge-8501375fcfa916aa0d256153690674f6.webp";